import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Form, message, Progress, Spin, Button } from 'antd';
import Section from './section';
import { uploadSection } from '../../../../core/actions/coursePost';

const antIcon = progress => (
  <Progress
    type="circle"
    percent={progress}
    format={() => (progress === 100 ? 'Done' : `${progress}%`)}
    width={80}
  />
);
class CourseCurriculum extends Component {
  constructor(props) {
    super(props);

    this.state = {
      courseId: 'ujz9CN4EaTli1SBZuCkm',
      sections: [
        { id: Math.round(Math.random() * 100), title: '', lectures: [{ id: Math.round(Math.random() * 100), title: '', video: '' }] }
      ],
      sectionTitle: '',
      lectureTitle: '',
      fileList: [],
      loading: false,
      progress: 0,
      lectures: [1]
    };
    this.removeLecture = this.removeLecture.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleVideo = this.handleVideo.bind(this);
    this.updateCourseId = this.updateCourseId.bind(this);
    this.addSection = this.addSection.bind(this);
    this.removeSection = this.removeSection.bind(this);
    this.addNewLecture = this.addNewLecture.bind(this);
  }
  componentDidMount() {
    this.updateCourseId();
    this.props.getMedia(this.props.profile.uid)
  }
  componentWillReceiveProps(nextProps) {
    const {
      uploadSectionSuccess,
      uploadSectionError,
      loading,
      progress
    } = nextProps.course;
    if (uploadSectionSuccess) message.success(uploadSectionSuccess);
    if (uploadSectionError) message.error(uploadSectionError);
    if (progress !== this.state.progress) this.setState({ progress });
    this.setState({ loading });
  }
  updateCourseId() {
    const { courseId } = this.props.course;
    if (this.props.course.courseId) this.setState({ courseId });
  }
  addSection() {
    const { sections } = this.state;
    sections.push({
      id: Math.round(Math.random() * 100),
      title: '',
      lectures: [{ id: Math.round(Math.random() * 100), title: '', video: '' }]
    });
    this.setState({ sections });
  }
  removeSection(index) {
    const { sections } = this.state;
    sections.splice(index, 1);
    this.setState({ sections });
  }
  addNewLecture(sectionId) {
    const { sections } = this.state;
    sections[sectionId].lectures.push({ id: Math.round(Math.random() * 100), title: '', video: '' });
    this.setState({ sections });
  }
  removeLecture(sectionId, lectureIndex) {
    const { sections } = this.state;
    const sectionIndex = sections.findIndex(item => item.id === sectionId);
    sections[sectionIndex].lectures.splice(lectureIndex, 1);
    this.setState({ sections });
  }
  handleVideo(videoUrl, sectionIndx, lectureIndx) {
    const { sections } = this.state;
    const sectionIndex = sections.findIndex(section => section.id === sectionIndx);
    const lectureIndex = sections[sectionIndex].lectures.findIndex(lecture => lecture.id === lectureIndx);
    if (sections[sectionIndex] && sections[sectionIndex].lectures && sections[sectionIndex].lectures[lectureIndex]) {
      if (videoUrl) {
        sections[sectionIndex].lectures[lectureIndex].video = videoUrl;
      } else {
        sections[sectionIndex].lectures[lectureIndex].video = '';
      }
    }
    this.setState({ sections });
  }
  uploadFile = ({fileData,sectionIndx, lectureIndx})=>{
    const { sections } = this.state;
    // const sectionIndex = sections.findIndex(section => section.id === sectionIndx);
    // const lectureIndex = sections[sectionIndex].lectures.findIndex(lecture => lecture.id === lectureIndx);
    if (sections[sectionIndx] && sections[sectionIndx].lectures && sections[sectionIndx].lectures[lectureIndx]) {
      if (fileData) {
        sections[sectionIndx].lectures[lectureIndx].files ? sections[sectionIndx].lectures[lectureIndx].files.push(fileData):
        sections[sectionIndx].lectures[lectureIndx].files = [fileData]
      } 
    }
    this.setState({ sections });
  }
  removeFile = ({fileData,sectionIndx, lectureIndx})=>{
    const { sections } = this.state;
    // const sectionIndex = sections.findIndex(section => section.id === sectionIndx);
    // const lectureIndex = sections[sectionIndex].lectures.findIndex(lecture => lecture.id === lectureIndx);
    if (sections[sectionIndx] && sections[sectionIndx].lectures && sections[sectionIndx].lectures[lectureIndx]) {
      if (fileData) {
      var newFiles =  sections[sectionIndx].lectures[lectureIndx].files.filter((f)=>{
        if(fileData.url){
          return f.url !=fileData.url
        } else return f.name !=fileData.name
      })
      sections[sectionIndx].lectures[lectureIndx].files = newFiles;
      } 
    }
    this.setState({ sections });
  }
  handleSubmit(e) {
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      if (!err) {
        const { sections, courseId } = this.state;
        Object.keys(values).forEach((i) => {
          const item = i.split('|');
          const sectionIndex = sections.findIndex(section => section.id === Number(item[0]));
          const lectureIndex = sections[sectionIndex].lectures.findIndex(lecture => lecture.id === Number(item[2]));
          const name = item[1];
          const value = values[i];

          if (lectureIndex !== -1) {
            if (sections[sectionIndex] && sections[sectionIndex].lectures && sections[sectionIndex].lectures[lectureIndex]) {
              sections[sectionIndex].lectures[lectureIndex][name] = value;
            }
          } else {
            sections[sectionIndex][name] = value;
          }
        });
        if (!courseId) {
          message.error('please save course information first');
        } else {
          this.setState({
            sections
          }, () => this.props.uploadSection(sections, this.state.courseId));
        }
      } else {
        // eslint-disable-next-line no-console
        console.log(err);
      }
    });
  }
  render() {
    const { getFieldDecorator } = this.props.form;
    const { progress, loading, sections } = this.state;
    return (
      <Spin indicator={antIcon(progress)} spinning={loading}>
        <div className="courseCurriculumCard">
          <Form onSubmit={this.handleSubmit} className="curriculum-form" >
            <div className="add-section-btn">
              <Button
                onClick={() => this.addSection()}
                className="remove-lecture-btn"
                size="small"
                type="primary"
                ghost
              >
                Add Section
              </Button>
            </div>
            {sections.map((section, index) => (
              <Section
                key={index}
                uploadMedia={this.props.uploadMedia}
                refreshVideos={this.props.refreshVideos}
                refresh={this.props.refresh}
                getMedia={this.props.getMedia}
                profile={this.props.profile}
                media={this.props.media}
                sectionId={section.id}
                sections={sections}
                sectionIndex={index}
                section={section}
                uploadFile={this.uploadFile}
                removeFile={this.removeFile}
                getFieldDecorator={getFieldDecorator}
                lectures={section.lectures}
                addNewLecture={this.addNewLecture}
                removeLecture={this.removeLecture}
                removeSection={this.removeSection}
                handleSubmit={this.handleSubmit}
                handleVideo={this.handleVideo}
              />
            ))}
            <div className="save-btn">
              <Button type="primary" htmlType="submit" className="login-form-button">
                Save
              </Button>
            </div>
          </Form>
        </div>
      </Spin>
    );
  }
}
const mapStateToProps = state => ({
  course: state.course
});
const mapDispatchToProps = dispatch => ({
  uploadSection: (sectionInfo, courseId) =>
    dispatch(uploadSection(sectionInfo, courseId))
});

const CourseCurriculumForm = Form.create()(CourseCurriculum);

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CourseCurriculumForm);
